import { render, staticRenderFns } from "./restorePass.vue?vue&type=template&id=5f02b603&"
import script from "./restorePass.vue?vue&type=script&lang=js&"
export * from "./restorePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports